<template>
  <div>
    <div class="bg1">
      <div class="page_title_contain">
        <header
          class="other_page_head"
          style="background: none; box-shadow: none"
        >
          <div class="common_warp header_wrap">
            <div
              class="icon"
              @click="
                () => {
                  $router.push('/home')
                }
              "
            >
              <img src="../assets/eamaster_logo_title_index.png" alt="" />
            </div>

            <div class="language other_page_language">
              <span
                class="pointer"
                @click="
                  () => {
                    $router.push('/')
                  }
                "
                >中文</span
              ><span class="line">|</span
              ><span
                class="pointer"
                @click="
                  () => {
                    $router.push('english')
                  }
                "
                >English</span
              >
            </div>
          </div>
        </header>
      </div>
    </div>
    <div class="about">
      <div class="title">About EAmaster</div>
      <div class="subtitle">Find programs worth a student's time.</div>
      <div class="text">
        EAmaster helps students in grades 7–12, their families, and school
        counselors discover and compare extracurricular opportunities in China
        and around the world.
      </div>
      <div class="text">
        Our website and WeChat mini-program host a growing selection of 300+
        programs across ten-plus categories, from research and competitions to
        summer programs, tech, arts, and community service.
      </div>

      <div class="sub_title">Why we built it</div>
      <div class="text">
        Good programs can be difficult to find and even harder to evaluate.
        Information is scattered across different websites, and a polished
        brochure doesn't always tell you what a student will actually do,
        learn, or take away.
      </div>
      <div class="text">
        As parents of teenagers navigating this landscape themselves, our
        founders understand these challenges firsthand. We believe the right
        extracurricular experiences help students build practical skills,
        explore genuine interests, and discover what matters to them. These
        experiences have value long before they become part of a college
        application.
      </div>

      <div class="sub_title">Who is behind it</div>
      <div class="text">
        Our team brings deep experience across international admissions,
        edtech, and student advising. We've seen firsthand how real-world
        experiences, genuine interests, and personal growth shape a student's
        educational journey.
      </div>
      <div class="text">That perspective drives the questions we ask about every program:</div>
      <ul class="bullet_list">
        <li>What will students actually do?</li>
        <li>Who is this program truly designed for?</li>
        <li>What skills and insights will they gain?</li>
        <li>How can families determine if it's the right fit?</li>
      </ul>

      <div class="sub_title">How we review programs</div>
      <div class="text">
        We compile program information from public sources and seek confirmation
        from organizers where possible. Depending on the listing, we review
        details such as eligibility, dates, fees, and program structure.
      </div>
      <div class="text">
        We aim to give students and families a clearer picture of what's
        offered, what is known, and what they should consider before applying.
        We do not assume that every program is right for every student, or that
        a prestigious name alone guarantees a meaningful experience.
      </div>
      <div class="text">
        As our resource grows, we also want to bring more student perspectives
        into the conversation, helping families understand what participating in
        a program can actually be like.
      </div>

      <div class="sub_title">Our independence</div>
      <div class="text">
        All program listings are free, with no paid placement. Programs do not
        pay to appear in our directory.
      </div>
      <div class="text">
        EAmaster is independently funded by our mission-driven founders.
      </div>

      <div class="sub_title">Where to start</div>
      <ul class="bullet_list">
        <li>
          <strong>Students:</strong> Explore programs by category and interest.
        </li>
        <li>
          <strong>Parents:</strong> Learn what to look for when comparing
          programs.
        </li>
        <li>
          <strong>School Counselors:</strong> Contact us to receive our industry
          white paper and explore extracurricular opportunities to share with
          your students.
        </li>
      </ul>

      <div class="text closing">
        We are committed to helping students and families discover opportunities
        through clear, reliable information, with students' interests at the
        center of what we do.
      </div>
    </div>
    <div class="bg3">
      <img src="@/assets/icon_star@2x.png" alt="" />
      <p>
        How it<br />
        works for YOU
      </p>
    </div>

    <div class="bg4">
      <div class="text">
        Constantly collaborating with universities, high schools, and other
        activity organizers, we provide up-to-date information regarding summer
        programs, academic competitions, community services, etc. At EAmaster,
        we've made it simple for students of all backgrounds to find
        extracurricular activities that align with their interests and skills.
      </div>
      <div class="text">
        You can search for programs directly on eamaster.com in two methods.
        First, users can conduct keyword searches, similar to Baidu and other
        search engines. To accomplish this, navigate to EAmaster's homepage bar
        and enter the categories of programs you're seeking in the search bar.
        Additionally, you can filter programs by study area, start date, grade,
        and more.
      </div>
      <div class="text">
        Educators are encouraged to contact us in order to receive a
        complimentary copy of the "Activity White Paper," an annual directory
        containing a selection of activities from various categories.
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
.bg1 {
  margin: 0 auto;
  width: 1920px;
  height: 720px;
  background: url('~@/assets/pic_bg_1@2x.png') no-repeat top center/cover;
}
.about {
  width: 1920px;
  padding: 100px 360px 100px 360px;
  margin: 0 auto;
  background-color: #ffffff;
  background-image: url('~@/assets/about us@2x.png');
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 100% 804px;
  .title {
    font-size: 54px;
    font-family: Arial-Black, Arial;
    font-weight: 900;
    color: #333333;
    line-height: 76px;
    margin-bottom: 12px;
    text-align: center;
  }
  .subtitle {
    font-size: 26px;
    font-family: Arial-Black, Arial;
    font-weight: 900;
    color: #ff7200;
    line-height: 36px;
    text-align: center;
    margin-bottom: 48px;
  }
  .sub_title {
    font-size: 28px;
    font-family: Arial-Black, Arial;
    font-weight: 900;
    color: #333333;
    line-height: 40px;
    margin: 56px 0 16px 0;
    padding-left: 18px;
    border-left: 6px solid #ff7200;
  }
  .bullet_list {
    margin: 8px 0 20px 0;
    padding: 0;
    list-style: none;
    li {
      position: relative;
      padding-left: 24px;
      font-size: 18px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #333333;
      line-height: 28px;
      margin-bottom: 12px;
      strong {
        font-weight: bold;
      }
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 10px;
        width: 8px;
        height: 8px;
        border-radius: 4px;
        background: #ff7200;
      }
    }
  }
  .closing {
    margin-top: 48px;
  }
}
.bg3 {
  width: 1920px;
  margin: 0 auto;
  height: 638px;
  background: url('~@/assets/pic_bg_3@2x.png') no-repeat top center/cover;
  padding: 200px 0px 0px 360px;
  img {
    width: 68px;
    height: 68px;
    margin-bottom: 40px;
  }
  p {
    font-size: 54px;
    font-family: Arial-Black, Arial;
    font-weight: 900;
    color: #ffffff;
    line-height: 76px;
  }
}
.bg4 {
  width: 1920px;
  margin: 0 auto;
  height: 871px;
  background: url('~@/assets/pic_bg_4@2x.png') no-repeat top center/cover;
  padding: 80px 360px 0px 360px;
  .text {
    font-size: 18px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #333333;
    line-height: 28px;
    margin-bottom: 20px;
  }
}
.text {
  font-size: 18px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #333333;
  line-height: 28px;
  margin-bottom: 20px;
}
</style>
